import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';
import { SelectOptionProps } from '../../SelectOption.types';
import { ControlProps } from './Control.types';

export const useStyles = ({
  isDisabled,
  error,
  menuPlacement,
  menuIsOpen,
}: Pick<ControlProps, 'isDisabled'> &
  Pick<SelectOptionProps, 'error' | 'menuPlacement' | 'menuIsOpen'>) => {
  const styles = useStyleSheet(
    (theme) => {
      const getBoxShadow = () => {
        if (!menuIsOpen) {
          return theme.boxShadows.secondary.inset;
        }

        if (menuPlacement === 'top') {
          return `rgba(0,0,0, 0.1) 0px 4px 4px`;
        }

        return `rgba(0,0,0, 0.1) 0px -4px 4px`;
      };

      return {
        root: {
          transition: 'none',
          borderRadius: theme.borderRadius.sm,
          boxShadow: getBoxShadow(),
          minHeight: '34px',
          backgroundColor: isDisabled
            ? theme.palette.background.secondary
            : theme.palette.common.white,

          position: 'relative',
          zIndex: 200,
          border:
            !isDisabled && error && !menuIsOpen
              ? `1px solid ${theme.palette.error.main} !important`
              : 'none',
        },
      };
    },
    [isDisabled, error, menuPlacement, menuIsOpen],
  );

  return styles;
};
